<template>
  <div class="dob-select-group">
    <!-- Year -->
    <div class="year">
      <!-- <v-select
          @change="updateDays()"
          :options="years"
          label="year"
          v-model="selectedYear"
          name="Year"
      ></v-select> -->
      <select v-model="selectedYear">
        <option value="" selected disabled>- {{ $t('year') }} -</option>
        <option v-for="year in years" :key="year.year" :value="year.year">
          {{ year.year }}
        </option>
      </select>
    </div>

    <!-- Month -->
    <div class="month">
      <!-- <v-select
         @change="updateDays()"
         :options="months"
         v-model="selectedMonth"
         label="month"
         :reduce="country => country.code"
         name="Month"
     ></v-select> -->
      <select v-model="selectedMonth" name="Month">
        <option value="" selected disabled>- {{ $t('month') }} -</option>
        <option v-for="(month, index) in months" :disabled="month.disabled" :value="index" :key="month.month">
          {{ month.month }}
        </option>
      </select>
    </div>

    <!-- Day -->
    <div class="day">
      <!-- <v-select
          :options="days"
          v-model="selectedDay"
          label="day"
          name="Day"
      ></v-select> -->
      <select v-model="selectedDay">
        <option value="" selected disabled>- {{ $t('day') }} -</option>
        <option v-for="day in days" :disabled="day.disabled" :key="day.day" :value="day.day">
          {{ day.day }}
        </option>
      </select>
    </div>


  </div>
</template>

<script>

const defaultMonths = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
}

export default {
  name: "DateDropdown",
  props: {
    value: String,
    min: {
      type: Date,
      required: false
    },
    max: {
      type: Date,
      required: false
    }
  },

  $_veeValidate: {
    value() {
      return this.calculatedDate;
    }
  },

  data () {
    return {
      selectedDay: '',
      selectedMonth: '',
      selectedYear: ''
    }
  },

  computed: {
    // Returns if there are default date settings.
    initialDate() {
      return !! (this.min)
    },

    // The minimum date the will allow user to select.
    minDate() {
      if (this.min) {
        return this.min
      }
      return null;
    },

    // The maximum date the will allow user to select.
    maxDate() {
      if (this.max) {
        return this.max
      }
      return null;
    },

    // Returns a formatted date e.g. 01.02.2018.
    calculatedDate() {
      let self = this;
      const day = self.selectedDay === '' ? '' : self.selectedDay >= 10 ? self.selectedDay : `0${self.selectedDay}`
      const month = self.selectedMonth === '' ? '' : self.selectedMonth + 1 >= 10 ? self.selectedMonth + 1 : `0${self.selectedMonth + 1}`

      if (day === '' && month === '' && !self.year) {
        return '';
      }

      return `${self.selectedYear}-${month}-${day}`
    },

    // Computes the list of days.
    days() {
      let self = this;
      let days = []

      if (self.selectedYear.length === 0 || self.selectedMonth.length === 0) {
        return days;
      }

      let daysNumberOfMonth = new Date(self.selectedYear, self.selectedMonth + 1, 0).getDate()

      let months = self.months;
      let years = self.years;
      let selectedMonth = months[self.selectedMonth];
      let enabledMonths = months.filter((month) => !month.disabled);
      let firstMonthSelected = selectedMonth === enabledMonths[0];
      let lastMonthSelected = selectedMonth === enabledMonths[enabledMonths.length - 1];
      let minDateDay = self.minDate.getDate() + 1;
      let maxDateDay = self.maxDate.getDate();

      for (let i = 1; i < daysNumberOfMonth + 1; i++) {
        if (self.selectedYear === years[0].year && firstMonthSelected && i < minDateDay) {
          days.push({day: i, disabled: true});
        }
        else if (self.selectedYear === years[years.length - 1].year && lastMonthSelected && i > maxDateDay) {
          days.push({day: i, disabled: true});
        }
        else {
          days.push({day: i, disabled: false});
        }
      }

      if (days[self.selectedDay - 1] && days[self.selectedDay - 1].disabled) {
        self.selectedDay = '';
      }

      return days.map((day) => {
        return {day: day.day, disabled: day.disabled, selected: days === self.selectedDay }
      })
    },

    // Computes a list of month.
    months() {
      let months = [];
      let self = this;

      if (self.selectedYear.length === 0) {
        return months;
      }

      let minDateMonth = self.minDate.getMonth();
      let maxDateMonth = self.maxDate.getMonth();
      let years = self.years;

      for (let i = 0; i < 12; i++) {
        if (self.selectedYear === years[0].year && i < minDateMonth) {
          months.push({month: defaultMonths[i], disabled: true});
        }
        else if (self.selectedYear === years[years.length - 1].year && i > maxDateMonth) {
          months.push({month: defaultMonths[i], disabled: true});
        }
        else {
          months.push({month: defaultMonths[i], disabled: false});
        }

      }

      if (months[self.selectedMonth] && months[self.selectedMonth].disabled) {
        self.selectedMonth = '';
        self.selectedDay = '';
      }

      return months.map((month, index) => {
        return { month: month.month, disabled: month.disabled, selected: index === self.selectedMonth }
      })
    },

    // Computes a list of years.
    years() {
      // Set the first year of the array.
      let firstYear

      if (this.min) {
        firstYear = this.minDate.getFullYear()
      } else {
        firstYear = (new Date).getFullYear()
      }

      // Create a range of years to loop through which is either the maximum
      // date minus the first year, or simply 100.
      let through = this.max ? (this.maxDate.getFullYear() + 1) - firstYear : 101
      let years = []

      for (let i = firstYear, len = firstYear + through; i < len; i++)
        years.push(i)

      return years.map((year) => {
        return { year, selected: year === this.selectedYear }
      })
    }
  },

  methods: {

    // Send data to upper component.
    sendDate() {
      const date = this.format ? this.format(this.calculatedDate) : this.calculatedDate

      this.$emit('input', date)
    },

    // Set the initial date.
    setDate() {
      // If a value property has been passed to the component, that will be
      // used instead of the current day.
      let date;

      let self = this;

      if (self.value) {

        date = self.$moment(self.value).toDate();
        this.selectedMonth = date.getMonth();
        this.selectedDay = date.getDate();
        this.selectedYear = date.getFullYear();

        self.sendDate();
      }
    }
  },

  created() {
    this.setDate()
  },

  updated() {
    this.sendDate()
  },
}
</script>